import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { favoritesApi } from '../../api/favorites'
import Header from '../../components/layout/Header'
import Footer from '../../components/layout/Footer'
import Loading from '../../components/common/Loading'
import CourseCard from '../../components/course/CourseCard'
import './Favorites.css'

const Favorites = () => {
  const queryClient = useQueryClient()

  const { data, isLoading } = useQuery({
    queryKey: ['favorites'],
    queryFn: () => favoritesApi.getFavorites(),
  })

  const removeMutation = useMutation({
    mutationFn: (id) => favoritesApi.removeFavorite(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['favorites'])
    },
  })

  if (isLoading) {
    return (
      <>
        <Header />
        <Loading fullScreen text="جاري التحميل..." />
        <Footer />
      </>
    )
  }

  const favorites = data?.data?.favorites || []
  const grouped = data?.data?.grouped || { courses: [], lectures: [], instructors: [] }
  const courses = grouped.courses || []

  return (
    <div className="favorites-page bg-gray-900 min-h-screen">
      <Header />
      <main className="favorites-main bg-gray-900">
        <div className="container mx-auto px-4 py-8">
          <h1 className="page-title text-white">المفضلة</h1>
          {courses.length > 0 ? (
            <div className="courses-grid">
              {courses.map((course) => (
                <CourseCard key={course.id} course={course} />
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <p>لا توجد دورات في المفضلة</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Favorites

